import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Image from "src/components/Image";
import { entitiesLogoUrl } from "src/utils/formatUrl";

import Context from "../../context";

// ----------------------------------------------------------------------

export const EntityLogo = () => {
	const { state, theme } = useContext(Context);

	return (
		<Stack
			sx={{
				gap: 2,
				alignItems: "center",
				flexDirection: "row"
			}}
		>
			<Image
				sx={{
					height: 30
				}}
				src={entitiesLogoUrl(state.entity?.id ?? "")}
				fit='cover'
			/>
			<Typography variant='h4' color={theme?.colors.primaryText}>
				{state.entity?.name}
			</Typography>
		</Stack>
	);
};

export default EntityLogo;
